import React, { memo, useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import styles from './PartAdvert.module.less';
import { logging } from '../../actions/log';
import { setIframeVisible } from '../../actions/layout';
import { hasClass, removeClass, addClass, logNative } from '../../utils/utils';

const formatMoney = money => {
  try {
    let unit = '';
    let num = money;
    if (+money >= 10000) {
      num = money / 10000;
      unit = 'w';
      if (money % 10000) {
        num = num.toFixed(1);
      }
    }
    if (+money < 10000) {
      num = money.toString().substr(0, 4);
      if (num.substr(-1) === '.') {
        num = num.substr(0, num.length - 1);
      }
    }

    return num + unit;
  } catch (err) {
    return money;
  }
};
const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);
export default memo(({ data, logInfo = {} }) => {
  const dispatch = useDispatch();
  const logInfoData = useSelector(selectLogInfo);

  const handleAdvert = useCallback(() => {
    if (data.targetType === '5' && data.targetContent) {
      let targetContent = {};
      try {
        targetContent = JSON.parse(data.targetContent);
      } catch (error) {
        logNative(`分析商城URL JSON解析错误:${error}`, error);
      }
      if (targetContent && targetContent.url) {
        dispatch(
          setIframeVisible({
            visible: true,
            url: targetContent.url,
            data,
            source: logInfo.source,
          }),
        );
      }
    } else if (data.targetType === '2' || data.targetUrl) {
      if (data.targetUrl) {
        window.open(data.targetUrl);
      } else {
        // 对data.targetUrl无值时做一个兼容处理
        let targetContent = {};
        try {
          targetContent = JSON.parse(data.targetContent);
          window.open(targetContent.targetUrl);
        } catch (error) {
          logNative(`分析商城URL JSON解析错误:${error}`, error);
        }
      }
    }
    // 点击card
    dispatch(
      logging({
        category: 'C',
        action: logInfo.c_action,
        label: '',
        param2: {
          source: logInfo.source,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          name: data.name,
          id: data.id,
          // sku:
        },
      }),
    );
  }, []);

  const onMouseOver = useCallback(e => {
    const el = e.currentTarget.getElementsByClassName(styles.advert_img)[0];
    addClass(el, styles.image_mouse_in);
  }, []);

  const onMouseLeave = useCallback(e => {
    const el = e.currentTarget.getElementsByClassName(styles.advert_img)[0];
    addClass(el, styles.image_mouse_out);
  }, []);

  const onAnimationEnd = useCallback(e => {
    const el = e.currentTarget.getElementsByClassName(styles.advert_img)[0];
    if (hasClass(el, styles.image_mouse_out)) {
      removeClass(el, styles.image_mouse_in);
      removeClass(el, styles.image_mouse_out);
    }
  }, []);

  return (
    <div
      className={styles.advert}
      onClick={() => {
        handleAdvert();
      }}
      onMouseOver={e => onMouseOver(e)}
      onMouseLeave={e => onMouseLeave(e)}
      onAnimationEnd={e => onAnimationEnd(e)}
    >
      <div className={styles.advert_img_}>
        <img className={styles.advert_img} src={data.imgUrl} />
      </div>
      <div className={styles.advert_info}>
        <div className={styles.advert_info_left}>
          <div className={styles.advert_info_title}>{data.name}</div>
          <div className={styles.advert_info_desc}>{data.proDesc}</div>
        </div>
        <div className={styles.advert_info_split} />
        <div className={styles.advert_info_right}>
          <div className={styles.advert_info_now}>
            ￥{data.nowPrice ? formatMoney(data.nowPrice) : data.nowPrice}
          </div>
          {data.originalPrice && (
            <div className={styles.advert_info_original}>￥{formatMoney(data.originalPrice)}</div>
          )}
        </div>
      </div>
      {data.cornerText && <div className={styles.advert_tag}>{data.cornerText}</div>}
    </div>
  );
});
